import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const validateConfig: ConfigValidationFunction<PipelineStepType.WINDOW_FUNCTIONS, 0> = (
  config,
  {'Input dataset': [dataFrameSpec]}
) =>
  Helpers.coalesceMessages(
    Helpers.getDuplicateColumnsMessage(
      dataFrameSpec,
      config.orderByColumns.map((orderByColumn) => orderByColumn.column),
      'Cannot order by the same column more than once.'
    ),
    config.windows.map((window) =>
      Helpers.getDuplicateColumnsMessage(
        dataFrameSpec,
        window.orderByColumns.map((orderByColumn) => orderByColumn.column),
        'Cannot order by the same column more than once.'
      )
    ),
    config.windows.map((window) =>
      Helpers.getDuplicateColumnsMessage(
        dataFrameSpec,
        window.partitionColumns,
        'Cannot partition by the same column more than once.'
      )
    )
  );

export default {
  stepType: PipelineStepType.WINDOW_FUNCTIONS,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.WINDOW_FUNCTIONS, 0>;
